import React from 'react';
const TermsPage = () => {
  return <div className="container mx-auto px-4 py-12" data-id="element-386">
      <h1 className="text-3xl font-bold mb-8 text-[#1A2B4C]" data-id="element-387">
        Terms & Conditions
      </h1>
      <div className="bg-white rounded-lg shadow-sm p-8" data-id="element-388">
        <p className="mb-6" data-id="element-389">
          Welcome to Elevatefix. This website is owned and operated by
          Elevatefix. When we refer to "we," "us," or "our," we are referring to
          Elevatefix. These Terms and Conditions apply to your use of our
          website and your purchase of our appliance repair and service plans.
          By using our website or buying a service plan, you agree to these
          terms.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-390">
          Our Company Information
        </h2>
        <p className="mb-6" data-id="element-391">
          Business Name: Elevatefix
          <br data-id="element-392" />
          Website: elevatefix.it.com
          <br data-id="element-393" />
          Business Address: 1a Tower Workshops, 58 Riley Rd, London SE1 3DG
          <br data-id="element-394" />
          Customer Service Email: dronakoirala6@gmail.com
          <br data-id="element-395" />
          Phone Number: 0800 055 4969
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-396">
          About Our Services and Pricing
        </h2>
        <p className="mb-6" data-id="element-397">
          Elevatefix specialises in providing fast, reliable appliance repair
          and maintenance services across the UK. Our service plans are designed
          to give you peace of mind, offering unlimited repairs for a fixed
          price on your covered appliances during the plan's duration. You can
          find full details on what's included in each plan, along with pricing,
          on our website's service and checkout pages.
          <br data-id="element-398" />
          <br data-id="element-399" />
          All prices are shown in GBP (£). We accept all major debit and credit
          cards for secure payments.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-400">
          Order Confirmation
        </h2>
        <p className="mb-6" data-id="element-401">
          After you purchase a service plan, we will send you an email to
          confirm your order. If you do not receive this email within one hour,
          please contact our customer service team at dronakoirala6@gmail.com.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-402">
          Cancellation and Refunds
        </h2>
        <p className="mb-6" data-id="element-403">
          You have a 14-day cooling-off period starting from your purchase date
          to cancel your service plan and receive a full refund.
          <br data-id="element-404" />
          <br data-id="element-405" />
          For cancellations requested between 15 and 28 days after purchase, a
          partial refund may be offered at our discretion. Refunds are not
          available after 28 days.
          <br data-id="element-406" />
          <br data-id="element-407" />
          All approved refunds will be processed back to the original payment
          method. Please allow 5-10 working days for the amount to show in your
          account.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-408">
          Dispute Resolution
        </h2>
        <p className="mb-6" data-id="element-409">
          We are committed to providing excellent service. If you have any
          concerns or issues with your service plan or a charge, please contact
          us directly using the details above. We are here to help and will work
          with you to find a fair solution. We kindly ask that you contact us
          first before raising a chargeback with your bank, as this can often
          lead to longer resolution times.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-410">
          Important Exclusions
        </h2>
        <p className="mb-6" data-id="element-411">
          To ensure fairness and maintain the quality of our service, certain
          issues are not covered by our service plans. These exclusions include:
          <br data-id="element-412" />
          <br data-id="element-413" />
          <span className="font-medium" data-id="element-414">Pre-existing faults:</span> Any faults
          or damage that existed before your plan was activated.
          <br data-id="element-415" />
          <br data-id="element-416" />
          <span className="font-medium" data-id="element-417">Misuse or neglect:</span> Damage caused
          by improper use, neglect, or tampering with the appliance.
          <br data-id="element-418" />
          <br data-id="element-419" />
          <span className="font-medium" data-id="element-420">Unrelated repairs:</span> Issues not
          related to the appliance's normal function.
          <br data-id="element-421" />
          <br data-id="element-422" />
          <span className="font-medium" data-id="element-423">Improper use:</span> Appliances that
          have not been used in line with the manufacturer's guidelines.
          <br data-id="element-424" />
          <br data-id="element-425" />
          If it's found that a fault is a result of any of these conditions,
          your plan may be voided, and no refund or service will be provided.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-426">
          Updates to These Terms
        </h2>
        <p className="mb-4" data-id="element-427">
          We may update these terms from time to time. Your continued use of our
          services after any changes means you accept the updated terms.
        </p>
      </div>
    </div>;
};
export default TermsPage;